import DataLoaderStore from '../utils/stores/DataLoaderStore'
import { getDealerInfo } from '../services/ApiService'
import { observable } from 'mobx'

class DealerContractStore extends DataLoaderStore {
  constructor() {
    super({ action: getDealerInfo })

    observable(this, {
      contractDate: observable,
      contractNumber: observable,
    })
  }

  setContactData = (contractDate, contractNumber) => {
    this.contractDate = contractDate
    this.contractNumber = contractNumber
  }

  getContactData = () => {
    return {
      contractNumber: this.contractNumber,
      contractDate: this.contractDate,
    }
  }
}

export default DealerContractStore
